import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  padding-top: 56.25%;
`;

export const Video = styled.iframe`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  border: 0;
`;
